// modal-template-register.js
import axios from 'axios';
import { modal } from '../../modal-template/modal-template';

const classPrefix = 'modal-template-register';
const dataPrefix = 'data-modal-template-register';
import { input } from '../../input/input';
export function modalTemplateRegister($container, params = {referal: null}) {
    const $template = document.querySelector(`[${dataPrefix}-template]`)

    init();
    function init(){
        console.log(params)
        const $modalClone = document.importNode($template.content, true)

        const $form = $modalClone.querySelector(`[${dataPrefix}-form]`);
        const $restore = $modalClone.querySelector(`[${dataPrefix}-restore]`);
        const $confirm = $modalClone.querySelector(`[${dataPrefix}-confirm]`);

        renderFields($form)
        ensureStatusField($form);
        $confirm.addEventListener('click', () => {
            submitRegister($form, $confirm);
        });

        $container.appendChild($modalClone)
    }
    function renderFields($form) {
        // очищаем от предыдущих
        //$form.innerHTML = '';

        const $formReferal = $form.querySelector(`[${dataPrefix}-form-referal]`);
        if (params.referal) {
            $formReferal.value = params.referal;
        }

        input($form, {
            type: 'email',
            label: 'Email',
            name: 'email',
            autocomplete: 'email',
            required: true,
        });

        input($form, {
            type: 'name',
            label: "ФИО (для сертификатов)",
            name: 'name',
            autocomplete: 'name',
            required: true,
        });
    }

    function ensureStatusField($form) {
        // общий статус/ошибка
        let $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) {
            $status = document.createElement('div');
            $status.className = `${classPrefix}__status`;
            $form.appendChild($status);
        }
    }
    function setStatusMessage($form, message, isError = true) {
        const $status = $form.querySelector(`.${classPrefix}__status`);
        if (!$status) return;
        $status.textContent = message || '';
        $status.style.display = message ? 'block' : 'none';
        $status.classList.toggle('is-error', isError);
    }
    function clearErrors($form) {
        // удаляем старые текстовые сообщения ошибок под input'ами
        $form.querySelectorAll(`.${classPrefix}__field-error`).forEach(e => e.remove());
        setStatusMessage($form, '');
        // сброс состояния инпутов
        $form.querySelectorAll('input, textarea').forEach(el => {
            el.classList.remove('is-invalid');
        });
    }

    async function submitRegister($form, $confirmBtn) {
        clearErrors($form);
        setStatusMessage($form, '');

        const payload = {};

        const $formReferal = $form.querySelector(`[${dataPrefix}-form-referal]`);
        payload['referal'] = $formReferal.value;
        $form.querySelectorAll('input[name], textarea[name]').forEach(($el) => {
            const name = $el.getAttribute('name');
            // для чекбоксов/радио можно добавить ветку, но здесь простые поля
            payload[name] = $el.value;
        });

        // UI: блокируем кнопку
        const oldBtnText = $confirmBtn.textContent;
        $confirmBtn.setAttribute('disabled', 'true');
        $confirmBtn.classList.add('is-loading');
        $confirmBtn.textContent = 'Обработка...';

        // Настройки axios для laravel
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.common['Accept'] = 'application/json';

        // CSRF: попробуем прочитать meta-tag, если он есть
        const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        if (metaToken) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = metaToken;
        }

        try {
            // Подмените URL на ваш роут логина, если он другой
            const response = await axios.post('/register', payload);

            modal.open('register-final', { userId: response.data.user_id });

        } catch (error) {
            setStatusMessage($form, error.response.data.message, true);
            console.error(error);
        } finally {
            // разблокируем кнопку
            $confirmBtn.removeAttribute('disabled');
            $confirmBtn.classList.remove('is-loading');
            $confirmBtn.textContent = oldBtnText;
        }
    }
}
